import { metrics } from '../index';

export const httpRequestTiming = ({
  method = '',
  status = 0,
  duration,
  endpointName = '',
  isUpstream = false,
  extraTags = [],
}) => {
  const statusCodeGroup = status > 0 ? `${Math.floor(status / 100)}xx` : status;
  const metric = `${isUpstream ? 'upstream.' : ''}request`;

  metrics.timing(metric, duration, [
    `endpoint-name:${endpointName.toLowerCase()}`,
    `http-method:${method.toUpperCase()}`,
    `status-code:${status}`,
    `status-code-group:${statusCodeGroup}`,
    ...extraTags,
  ]);
};



// WEBPACK FOOTER //
// ./src/metrics/lib/httpRequestTiming.js